<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';

  export default {
    page: {
      title: 'List of Device',
      meta: [{
        name: "description",
        content: appConfig.description
      }],
    },
    data() {
      return {
        title: this.$route.params.brand,
        items: [{
            text: "Device",
            href: "/",
          },
          {
            text: this.$route.params.brand,
            active: true,
          },
        ],
        pagination: {
          enabled: true,
          limit: 10,
        },
        data: [],
        data_: [],
        DeviceSeenLoading: true,
        page: 1,
        perPage: 10,
        pages: [],
        hidePaging:false,
      };
    },
    name: "Widgets",
    components: {
      Layout,
      PageHeader,
      DataTable,
    },
    computed: {
      displayedPosts() {
        // console.log('llllllll');
        return this.paginate(this.data);
      },

      resultQuery() {
        // console.log('kkkkkk');
        if (this.searchQuery) {
          const search = this.searchQuery.toLowerCase();
          return this.displayedPosts.filter((data) => {
            return (
              data.pid.toLowerCase().includes(search) ||
              data.type.toLowerCase().includes(search) ||
              data.model.toLowerCase().includes(search) ||
              data.storage.toLowerCase().includes(search) ||
              data.ConA.toLowerCase().includes(search) ||
              data.ConB.toLowerCase().includes(search) ||
              data.ConC.toLowerCase().includes(search) ||
              data.ConD.toLowerCase().includes(search) ||
              data.ConE.toLowerCase().includes(search) 
            );
          });
        } else {
          return this.displayedPosts;
        }
      },
    },
    mounted() {
      // console.log('hhhhhh');
      this.getDevicesDetails();
    },
    watch: {
      posts() {
        // console.log('gggggg');
        // this.setPages();
      },
    },
    created() {
      // console.log('fffffff');
      // this.setPages();
    },
    filters: {
      
      trimWords(value) {
        return value.split(" ").splice(0, 20).join(" ") + "...";
      },
    },
    methods: {

        async getDevicesDetails(){

            if (typeof this.$route.params.currency !== 'undefined') {
                this.url_default = 'priceInfo/'+this.$route.params.brand+'/'+ this.$route.params.currency;
            }else{
                this.url_default ='priceInfo/'+this.$route.params.brand;
            }
            console.log(process.env.VUE_APP_API_BASEURL+this.url_default);
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            await axios.get(process.env.VUE_APP_API_BASEURL+this.url_default)
            .then(response => {
                if (response) {
                    if(response.data.status=='error'){
                        // console.log('aaaaaaaaaa');
                        this.messageBag = response.data.msj;
                        this.DeviceSeenLoading = false;
                    }else{
                      // console.log('bbbb');
                        this.data = response.data;
                        this.data_ = response.data;
                        this.DeviceSeenLoading = false;
                        // console.log(this.data);
                    }
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.detailSeenLoading = false;
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.detailSeenLoading = false;
            });

            this.detailSeenLoading=false;
        },
        
      // async setPages() {
      //   await  this.getDevicesDetails();
      //   let numberOfPages = Math.ceil(this.data.length / this.perPage);
      //   for (let index = 1; index <= numberOfPages; index++) {
      //     this.pages.push(index);
      //   }
      // },
      // paginate(data) {
      //   let page = this.page;
      //   let perPage = this.perPage;
      //   let from = page * perPage - perPage;
      //   let to = page * perPage;
      //   return data.slice(from, to);
      // },


       SearchBar(search){
          if(!search){
            window.location.reload();
            
          }
          this.DeviceSeenLoading=true;
          const posting_ = { search: this.search };

          axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
          axios.post(process.env.VUE_APP_API_BASEURL+'priceinfo/'+this.$route.params.brand, posting_)
          .then(response => {

              if (response) {
                  // console.log(response);
                  this.data = response.data;
                  // console.log(this.data);
                  this.DeviceSeenLoading=false;
                  this.hidePaging = true;
              } else {
                  this.messageBag = ['No record.'];
                  this.DeviceSeenLoading=false;
              }
          })
              .catch(error => {
                  this.messageBag = [error.error];
                  this.DeviceSeenLoading=false;
          });

      },
    },
  };
  require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="card card-body">
        <div class="card-body">
            <div v-if="DeviceSeenLoading">
            Loading
            </div>
            <div v-else>
                
                <div class="table-responsive table-card" v-if="!hidePaging">
                    <!-- <div class="col-lg-3">
                      <div class="input-group">
                  
                            <input v-model="search" type="text" placeholder="example: Iphone 13 Max" class="form-control">
                            <button class="btn btn-outline-success" @click="SearchBar(search)" type="button" id="button-addon2">
                                <i class="ri-search-line"></i>
                            </button>
                              
                      </div>
                  </div>
                   <br> -->
                    <DataTable class="table align-middle table-nowrap">
                        <thead class="table-light text-muted">
                            <tr>
                                <th class="sort" data-sort="currency_name" scope="col">Pid</th>
                                <th class="sort" data-sort="current_value" scope="col">Type</th>
                                <th class="sort" data-sort="pairs" scope="col">Model</th>
                                <th class="sort" data-sort="high" scope="col">Storage</th>
                                <th class="sort" data-sort="high" scope="col">Currency</th>
                                <th class="sort" data-sort="low" scope="col">Grade A</th>
                                <th class="sort" data-sort="low" scope="col">Grade B</th>
                                <th class="sort" data-sort="low" scope="col">Grade C</th>
                                <th class="sort" data-sort="low" scope="col">Grade D</th>
                                <th class="sort" data-sort="low" scope="col">Grade E</th>
                            </tr>
                        </thead>
                        <!--end thead-->
                        <tbody class="list form-check-all">
                            <tr v-for="(data, index) of data_" :key="index">
                                <td class="id">
                                {{ data.pid }}
                                </td>
                                <td>{{ data.type }}</td>
                                <td>{{ data.model }}</td>
                                <td>{{ data.storage }}</td>
                                <td>{{ data.ram }}</td>
                                <td>{{ data.ConA.toLocaleString('en-US') }}</td>
                                <td>{{ data.ConB.toLocaleString('en-US') }}</td>
                                <td>{{ data.ConC.toLocaleString('en-US') }}</td>
                                <td>{{ data.ConD.toLocaleString('en-US') }}</td>
                                <td>{{ data.ConE.toLocaleString('en-US') }}</td>
                            </tr>
                        </tbody>
                        <!--end tbody-->
                    </DataTable>
                </div>
                <div class="d-flex justify-content-end mt-3" v-if="!hidePaging">
                    <div class="pagination-wrap hstack gap-2">
                        <a class="page-item pagination-prev disabled" href="#" v-if="page != 1" @click="page--">
                            Previous
                        </a>
                        <ul class="pagination listjs-pagination mb-0">
                            <li :class="{
                                active: pageNumber == page,
                                disabled: pageNumber == '...',
                                }" v-for="(pageNumber, index) in pages.slice(page - 1, page + 5)" :key="index"
                                @click="page = pageNumber">
                                <a class="page" href="#">{{ pageNumber }}</a>
                            </li>
                        </ul>
                        <a class="page-item pagination-next" href="#" @click="page++" v-if="page < pages.length">
                            Next
                        </a>
                    </div>
                </div>

            </div>
            <div class="table-responsive table-card" v-if="hidePaging">
                <div class="col-lg-3">
                    <div class="input-group">
                
                        <input v-model="search" type="text" placeholder="example: Iphone 13 Max" class="form-control">
                        <button class="btn btn-outline-success" @click="SearchBar(search)" type="button" id="button-addon2">
                            <i class="ri-search-line"></i>
                        </button>
                            
                    </div>
                </div>
                <br>
                <table class="table align-middle table-nowrap" id="customerTable">
                    <thead class="table-light text-muted">
                        <tr>
                            <th class="sort" data-sort="currency_name" scope="col">Pid</th>
                            <th class="sort" data-sort="current_value" scope="col">
                            Type
                            </th>
                            <th class="sort" data-sort="pairs" scope="col">Model</th>
                            <th class="sort" data-sort="high" scope="col">Storage</th>
                            <th class="sort" data-sort="low" scope="col">Grade A</th>
                            <th class="sort" data-sort="low" scope="col">Grade B</th>
                            <th class="sort" data-sort="low" scope="col">Grade C</th>
                            <th class="sort" data-sort="low" scope="col">Grade D</th>
                            <th class="sort" data-sort="low" scope="col">Grade E</th>
                        </tr>
                    </thead>
                    <!--end thead-->
                    <tbody class="list form-check-all">
                        <tr v-for="(item, index) in data" :key="index" class="content">
                            <td class="id">
                            {{ item.pid }}
                            </td>
                            <td>{{ item.type }}</td>
                            <td>{{ item.model }}</td>
                            <td>{{ item.storage }}</td>
                            <td>{{ item.ConA }}</td>
                            <td>{{ item.ConB }}</td>
                            <td>{{ item.ConC }}</td>
                            <td>{{ item.ConD }}</td>
                            <td>{{ item.ConE }}</td>
                        </tr>
                    </tbody>
                    <!--end tbody-->
                </table>
            </div>
        </div>

      </div>
    </div>
  </Layout>
</template>